import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkGetReferralRewardsRequest = {};
var _bulkGetReferralRewardsResponse = { rewardsInSite: '_rewardsInSite' };
var _coupon = { couponSpecification: '_v1Coupon' };
var _fixedAmountDiscount = { amount: 'DOUBLE' };
var _getReferralRewardRequest = {};
var _getReferralRewardResponse = { referralReward: '_referralReward' };
var _percentageDiscount = { percentage: 'DOUBLE' };
var _queryReferralRewardsRequest = {};
var _queryReferralRewardsResponse = { referralRewards: '_referralReward' };
var _referralReward = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    coupon: '_coupon',
};
var _rewardsInSite = { rewards: '_referralReward' };
var _v1Coupon = {
    minimumSubtotal: 'DOUBLE',
    fixedAmountOptions: '_fixedAmountDiscount',
    percentageOptions: '_percentageDiscount',
};
function resolveWixLoyaltyReferralRewardV1ReferralRewardsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/referral-rewards',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/referral-rewards',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a referral reward. */
export function getReferralReward(payload) {
    var _a = serializer(_getReferralRewardRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReferralRewardResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralReward: _referralReward,
        _v1Coupon: _v1Coupon,
    }).fromJSON;
    function __getReferralReward(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referral_reward',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.reward.v1.ReferralRewards.GetReferralReward',
            url: resolveWixLoyaltyReferralRewardV1ReferralRewardsUrl({
                protoPath: '/v1/referral-rewards/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReferralReward.fromReq = fromReq;
    __getReferralReward.__isAmbassador = true;
    return __getReferralReward;
}
/**
 * Retrieves a list of referral rewards, given the provided paging, filtering, and sorting.
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryReferralRewards(payload) {
    var _a = serializer(_queryReferralRewardsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReferralRewardsResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralReward: _referralReward,
        _v1Coupon: _v1Coupon,
    }).fromJSON;
    function __queryReferralRewards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referral_reward',
            method: 'POST',
            methodFqn: 'wix.loyalty.referral.reward.v1.ReferralRewards.QueryReferralRewards',
            url: resolveWixLoyaltyReferralRewardV1ReferralRewardsUrl({
                protoPath: '/v1/referral-rewards/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReferralRewards.fromReq = fromReq;
    __queryReferralRewards.__isAmbassador = true;
    return __queryReferralRewards;
}
/**
 * Retrieves rewards from all metasites that the caller is the member of.
 *
 * This method must be called with a [user identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities#wix-users).
 */
export function bulkGetReferralRewards(payload) {
    var _a = serializer(_bulkGetReferralRewardsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetReferralRewardsResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralReward: _referralReward,
        _rewardsInSite: _rewardsInSite,
        _v1Coupon: _v1Coupon,
    }).fromJSON;
    function __bulkGetReferralRewards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referral_reward',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.reward.v1.ReferralRewards.BulkGetReferralRewards',
            url: resolveWixLoyaltyReferralRewardV1ReferralRewardsUrl({
                protoPath: '/v1/bulk/referral-rewards',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetReferralRewards.fromReq = fromReq;
    __bulkGetReferralRewards.__isAmbassador = true;
    return __bulkGetReferralRewards;
}
//# sourceMappingURL=http.impl.js.map